export const environment = {
    production: false,
    api_url: "https://delo.store/",
    cdn_url: "https://assets.delo.store/",
    ws_url: "wss://ws.delo.store"
};
